import type { Doc } from "building-types/doc";
import type { DocEntityType } from "building-types/doc/docEntityTypes";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";

export type ReorderableDocEntityType = Extract<
  DocEntityType,
  | "LEVEL"
  | "STAIR_SYSTEM"
  | "STAIR_BLOCK"
  | "RAILING"
  | "RAILING_POST"
  | "BLOCK"
  | "ROOF"
  | "ROOM_LAYOUT"
  | "ROOM_LAYOUT_INSTANCE"
  | "ROOF_VOLUME"
  | "ROOF_SYSTEM"
  | "VIEW_OVERRIDE"
  | "ROOM"
  | "VIEW_TEMPLATE"
  | "ELECTRICAL_DEVICE"
  | "VIEW_TEMPLATE_OVERRIDE"
  | "EDGE_BEHAVIOR"
  | "SETTINGS_SET"
  | "ENTITY_SETTINGS"
  | "OPTION_TEMPLATE"
  | "FOUNDATION"
  | "FOUNDATION_ASSEMBLY"
  | "FOUNDATION_COMPONENT"
  | "FOUNDATION_SYSTEM"
  | "FRAME_FLOOR_ASSEMBLY"
  | "FRAMING_COMPONENT"
  | "CIP_COMPONENT"
  | "MASONRY_COMPONENT"
  | "SHEATHING_COMPONENT"
  | "SLAB_COMPONENT"
  | "SLAB_FLOOR_ASSEMBLY"
  | "DRAWING_REF"
  | "RULE_BASED_SELECTOR_INSTANCE"
  | "UNDERLAY"
  | "SHEET"
  | "REFERENCE_GEOM"
  | "FACADE"
  | "FACADE_SPAN_STRATUM"
  | "FACADE_SWEEP_STRATUM"
  | "ELEVATION"
  | "ANNOTATION"
  | "CASEWORK"
  | "CEILING"
  | "MODIFIER"
  | "PROP_INSTANCE"
  | "PROP"
  | "GROUP"
  | "FLOOR"
  | "FLOOR_FINISH"
  | "PRESET"
  | "PLAN_VIEW"
  | "VIEW_3D"
  | "ELEVATION_VIEW"
  | "COLUMN"
  | "PLAN_SET_TEMPLATE"
  | "PLAN_SET_TEMPLATE_CONFIG"
  | "CONTENT_TEMPLATE"
  | "CONTENT_TEMPLATE_INSTANCE"
  | "OPTION_RULE"
  | "WALL_PLANE_RULE"
  | "WALL_PLANE_TRIM"
  | "OPTION_LOCK"
  | "OPTION"
  | "ASSET"
  | "EFFECT"
  | "SITE"
  | "SITE_SHAPE"
  | "DATA_SEQUENCE"
  | "GLOBAL_PARAMETER"
  | "DATUM"
  | "OPENING"
  | "ELECTRICAL_LAYOUT"
  | "MEASUREMENT"
  | "PALETTE"
  | "FREEFORM_WALL"
  | "HEADER_ASSEMBLY"
  | "WALL_PLANE_ASSEMBLY"
>;

export const reorderableEntityTypes: { [K in ReorderableDocEntityType]: true } = {
  LEVEL: true,
  STAIR_SYSTEM: true,
  STAIR_BLOCK: true,
  RAILING: true,
  RAILING_POST: true,
  ELECTRICAL_DEVICE: true,
  BLOCK: true,
  ROOF: true,
  ROOM_LAYOUT: true,
  ROOM_LAYOUT_INSTANCE: true,
  PROP: true,
  VIEW_TEMPLATE: true,
  VIEW_TEMPLATE_OVERRIDE: true,
  OPTION: true,
  ROOF_SYSTEM: true,
  ROOF_VOLUME: true,
  VIEW_OVERRIDE: true,
  DATA_SEQUENCE: true,
  ROOM: true,
  EDGE_BEHAVIOR: true,
  RULE_BASED_SELECTOR_INSTANCE: true,
  SETTINGS_SET: true,
  ENTITY_SETTINGS: true,
  OPTION_TEMPLATE: true,
  FOUNDATION: true,
  FOUNDATION_ASSEMBLY: true,
  FOUNDATION_COMPONENT: true,
  FOUNDATION_SYSTEM: true,
  FRAME_FLOOR_ASSEMBLY: true,
  FRAMING_COMPONENT: true,
  CIP_COMPONENT: true,
  MASONRY_COMPONENT: true,
  SHEATHING_COMPONENT: true,
  SLAB_COMPONENT: true,
  SLAB_FLOOR_ASSEMBLY: true,
  DRAWING_REF: true,
  UNDERLAY: true,
  SHEET: true,
  REFERENCE_GEOM: true,
  FACADE: true,
  FACADE_SPAN_STRATUM: true,
  FACADE_SWEEP_STRATUM: true,
  ELEVATION: true,
  ANNOTATION: true,
  CASEWORK: true,
  CEILING: true,
  MODIFIER: true,
  PROP_INSTANCE: true,
  GROUP: true,
  FLOOR: true,
  FLOOR_FINISH: true,
  PRESET: true,
  PLAN_VIEW: true,
  VIEW_3D: true,
  ELEVATION_VIEW: true,
  COLUMN: true,
  PLAN_SET_TEMPLATE: true,
  PLAN_SET_TEMPLATE_CONFIG: true,
  CONTENT_TEMPLATE: true,
  CONTENT_TEMPLATE_INSTANCE: true,
  OPTION_RULE: true,
  WALL_PLANE_RULE: true,
  WALL_PLANE_TRIM: true,
  OPTION_LOCK: true,
  ASSET: true,
  EFFECT: true,
  SITE_SHAPE: true,
  SITE: true,
  GLOBAL_PARAMETER: true,
  DATUM: true,
  OPENING: true,
  ELECTRICAL_LAYOUT: true,
  MEASUREMENT: true,
  PALETTE: true,
  FREEFORM_WALL: true,
  HEADER_ASSEMBLY: true,
  WALL_PLANE_ASSEMBLY: true,
};

export function docEntityIsReorderable(_doc: Doc, handle: DocEntityHandle): boolean {
  if (!reorderableEntityTypes[handle.type]) {
    return false;
  }

  switch (handle.type) {
    case "ELEVATION_VIEW":
      return false;

    default:
      return true;
  }
}
